/* eslint-disable */
import React, { useState,useEffect } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars-2";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import UploadFile from "../../Api/UploadFile";
import { SelectCampaignTab } from "../../redux/actions/campaignAction";
import EmptySpaceFieldValid from "../Common/EmptySpaceFieldValid";
import {
  API_URL_FOR_CREATING_COMPAIGN_URL,
  CAMPAIGN_MANAGEMENT_URL,CAMPAIGN_APPROVAL_LIST
} from "../Shared/constant";
import { getPayloadCampaignAdd } from "../Shared/utils";
import Data from "./Component/Data";
import DatePickerCustom from "./Component/DatePickerCustom";
import FileUploader from "./Component/FileUploader";
import FormInput from "./Component/FormInput";
import FormSelectCustome from "./Component/FormSelectCustome";
import ModuleTitle from "./Component/ModuleTitle";
import SwitchCheckbox from "./Component/SwitchCheckbox";
import TextEditor from "./Component/TextEditor";
import VideoURLInput from "./Component/VideoURLInput";
import createSlug from "./CreateSlug";
import AddCampaign from "../../Api/AddCampaign";
import { toast } from "react-toastify";
import GetCampaignDetails from "../../Api/GetCampaignDetails";
import EditCampaign from "../../Api/EditCampaign";
import CommonLoader from "../Common/CommonLoader";
import { validateFormData } from "../Shared/utils";
import { getCompaignListForSequence } from "../../redux/actions/campaignAction";
import { GetRequestCallAPI } from '../../Api/GetRequest';
import CommonLogout from '../Common/CommonLogout';
import { floatValue } from "../Shared/utils";

const Add = () => {
  const dispatch = useDispatch();
  const Navigate = useNavigate();
      const Location = useLocation()?.pathname;
      const GetSlug = useLocation()?.pathname.split('/')[3];
      const CurrentUrlBaseMains = "/" + Location.split('/')[1] + "/" + Location.split('/')[2];

  const { accessToken } = useSelector((state) => state.personalReducers);
  const {
    campaignListIdWise,
    CurrenUrlBase,
    campaignList,
    campaignListForSequence,
  } = useSelector((state) => state.campaignReducers);

  const sequenceNumbers = campaignListForSequence
   ?.map((row) => row?.sequence_no) 
   ?.sort((a, b) => a - b)
   ?.filter((number) => number !== undefined && number !== null && number !== '')
   ?.join(", "); 
  const [prices, setPrices] = useState([]); 
  const [newPrice, setNewPrice] = useState("");
  const [msg, setMsg] = useState("");
  const [priceError, setPriceError] = useState("");
  const [msgError, setMsgError] = useState("");
  const [ LoaderStart, setLoaderStart ] = useState(false);
  const [loading,setLoading] = useState(false)
  const addPrice = () => {
    const priceValue = parseFloat(newPrice);
    if (priceValue < 5) {
      setPriceError("Contribution amount must be at least 5 $");
      return;
    }

    if (isNaN(priceValue) || newPrice.trim() === "") {
      setPriceError("Please enter a valid amount.");
      return;
    }
    const isDuplicatePrice = prices?.some(item => item?.amount === priceValue);
    if (isDuplicatePrice) {
      setPriceError("Amount is already added.");
      return;
    }

    if (!msg) {
      setMsgError("Contribution title is required.");
      return;
    }


   const Data ={
    amount :priceValue,
    text:msg
   }
    setPrices([...prices, Data]);
    setNewPrice("");
    setMsg("")
    setPriceError("");
    setMsgError("");
    setError({
      ...error,
      multiple_contributions: ""
    });
  };

  const handlePriceChange = (e) => {
    let value = e.target.value;  
    if (!/^\d*\.?\d{0,2}$/.test(value)) {
      return;
    }
    let priceValue = parseFloat(value);
  
    if (priceValue > 1000000) {
      setPriceError("Amount should not exceed 1,000,000.");
      return;
    } else {
      setPriceError("");
    }
  
    setNewPrice(value);
  };
  const handleMsgChange = (e) => {
    let value = e.target.value;  
    setMsg(value);
  };
  

  const removePrice = (index) => {
    const updatedPrices = prices?.filter((_, i) => i !== index);
    setPrices(updatedPrices);
  };
  

  const [uploadingFiles, setUploadingFiles] = useState({
    source_image: false,
    signature_logo: false,
    campaign_file_source: false,
    campaign_second_file_source: false,
    non_profit_file_source: false,
    supporting_sponsor_logos: false,
    sponsor_logo: false,
    signature_logo: false,
    company_file_source: false,
    initial_source_image: false,
  });
  const [formData, setFormData] = useState({
    avatar_validation: false,
    web_appearance: false,
    sequence_no: "",

    campaign_type: "",
    non_profit: "",
    ein_number: "",
    identify_non_profit: "",
    campaign_start_date: "",
    campaign_end_date: "",
    // start_date: null,
    // end_date: null,
    // receive_mosaic_earlier: "No",
    // need_mosaic_by: "",
    // mosaic_display_method: "",
    // mosaic_display_option: "",
    source_image: null,
    campaign_goal: "",
    financial_progress: true,
    contributions_key_type: "",
    contributions_value_type: "",
    contributions_option_list: [],
    // manage_campaign: "",
    // fundraising_campaign: "Yes",
    // partner_with_non_profit: "Yes",
    // campaign_users: [],
    // campaign_story: "",
    campaign_title: "",
    campaign_sub_title: "",
    campaign_description: "",
    campaign_file_type: "image",
    campaign_file_source:[],
    campaign_file_source2:[],
    campaign_second_file_type: "image",
    campaign_second_file_source: [],
    campaign_second_file_source2: [],
    // campaign_second: false,
    // company_website: "",
    company_title: "",
    company_description: "",
    company_file_type: "image",
    company_file_source: "",
    company_file_source2: "",
    non_profit_website: "",
    non_profit_title: "",
    non_profit_description: "",
    non_profit_file_type: "image",
    non_profit_file_source: "",
    non_profit_file_source2: "",
    supporting_sponsors: "Yes",
    supporting_sponsors_campaign: "No",
    sponsor_signature: "Yes",
    sponsor_logo: "",
    signature_logo: [],
    upload_slogan: "",
    supporting_sponsor_logos: [],
    initial_source_image: "",
    
    // email_subject: "Thank You for Your Support!",
    // email_body: `<div><p>Dear {name},</p><p>"Thank you for supporting {campaign_name}! Your participation plays a vital role in making a difference and helps bring this mission to life, whether through a donation or by joining in other ways."</p><p><br /></p><p>Every contribution moves us one step closer to achieving our goal, and we're grateful to have you as part of our community.</p><p><br /></p><p>Want to stay involved? Visit {website_link} to learn more about the impact of your donation and how you can continue to support this cause.</p><p><br /></p><p>With gratitude,</p><p>{campaing_owner_name}</p></div>`,
    // attack_signature_sponsor_logos: true,
    // privacy_policy: false,
    // terms_conditions: false,
  });

  const [error, setError] = useState({
    campaign_type: "",
    non_profit: "",
    ein_number: "",
    identify_non_profit: "",
    campaign_start_date: "",
    source_image:"",
    campaign_end_date: "",
    campaign_title: "",
    campaign_sub_title: "",
    campaign_file_type: "",
    campaign_file_source: "",
    campaign_second_file_type: "",
    campaign_second_file_source: "",
    company_title: "",
    non_profit_file_type: "",
    non_profit_title: "",
    supporting_sponsors: "",
    supporting_sponsors_campaign: "",
    company_file_type: "",
    campaign_goal:"",
    contributions_key_type:"",
    contributions_value_type:"",
    campaign_description:"",
    sequence_no:"",
    company_description:"",
    upload_slogan:"",
    sponsor_logo:"",
    non_profit_file_source:"",
    non_profit_file_source2:"",
    supporting_sponsor_logos:"",
    company_file_source:"",
    multiple_contributions:"",
    campaign_file_source2:"",
    company_file_source2:"",
  });
    useEffect(()=>{
        fetchDataForSequenceNumber(1000, 1);
    },[])
    const fetchDataForSequenceNumber = async (userLimit, currentPage) => {
      let url = `${CAMPAIGN_APPROVAL_LIST}/${userLimit}/${currentPage}?method=main`;
      url += `&sort_by=added_by`;
      const response = await GetRequestCallAPI(url, accessToken);
      if (response?.status === 200) {
          dispatch(getCompaignListForSequence(response?.data?.data));
      } else if (response?.status === 403) {
        CommonLogout();
        dispatch(getCompaignListForSequence([]));
      } else {
          dispatch(getCompaignListForSequence([]));
      }
    };
  const validationRules = {
    campaign_type: { required: true, label: "This field" },
    non_profit: { required:formData.campaign_type==="Organization" ?   true : false,label: "This field "},
    campaign_start_date:{ required: true,label: "Start date"},
    campaign_end_date:{ required: true,label: "End date"},
    source_image:{ required: formData?.initial_source_image ?  false : true,label: "Image "},
    initial_source_image:{ required: formData?.source_image ?  false : true,label: "Image"},
    campaign_goal:{ required: true,label: "Financial goal",number:true, maxLength:5},
    contributions_key_type: { required: true, label: "This field" },
    contributions_value_type: { required: formData?.contributions_key_type === "fixed"||formData?.contributions_key_type === "minimum" ?  true : false==="minimum", label: formData?.contributions_key_type == "minimum"? "Minimum amount":"Fixed amount",number:true, maxLength:5 },
    multiple_contributions:{required:formData.contributions_key_type === "multiple" && prices?.length === 0?true:false,label:"Amount"},
 
    campaign_title: { required: true, label: "Campaign title" },
    campaign_sub_title: { required: true, label: "Campaign subtitle" },
    campaign_description: { required: true, label: "Campaign description" },
    campaign_file_type: { required: true, label: "This field" },
    campaign_file_source:{required:(formData.campaign_file_type === "image"&&formData?.campaign_file_source ===false)? true:false ,label:"Upload image", isMultiple:true},
    campaign_file_source2:{required:(formData.campaign_file_type === "video"&&formData?.campaign_file_source2===false) ?  true : false,label:"Video Link",isMultiple:true},
    // campaign_second_file_type: { required: true, label: "This field" },
    // campaign_second_file_source:{required:true, label:formData?.campaign_second_file_type == "image"?"Upload file" :"Video link"},
    sequence_no: { required:formData?.web_appearance ?  true :false, label: "Sequence no" },
    company_title: { required:true, label: "Name" },
    company_description: { required:true, label: "Description" },
    company_file_source:{required:(formData?.company_file_type === "image"&& formData?.company_file_source===false) ? true:false,label:"Upload image",isMultiple:true},
    company_file_source2:{required:(formData?.company_file_type === "video"&& formData?.company_file_source2===false) ? true:false,label:"Video Link",isMultiple:true},

    non_profit_title: { required:formData?.non_profit === "Yes" ? true : false, label: "Name" },
    non_profit_description: { required:formData?.non_profit === "Yes" ? true : false, label: "Description " },
    non_profit_file_source: { required:(formData?.non_profit === "Yes" && formData?.non_profit_file_type === "image") ? true : false, label: "Upload image" },
    non_profit_file_source2: { required:(formData?.non_profit === "Yes" && formData?.non_profit_file_type === "video"&&formData?.non_profit_file_source2===false) ? true : false, label: "Video Link",isMultiple:true},
 
    sponsor_logo: { required:formData?.supporting_sponsors === "Yes" && formData?.sponsor_signature === "Yes" ? true:false, label: "Upload image" },
    supporting_sponsor_logos:{required:formData.supporting_sponsors_campaign === "Yes" ? true:false,label:"Upload image",isMultiple:true},
    upload_slogan: { required:true, label: "Slogan" },

};


  const handleDateChange = (name, date) => {
    setFormData((prev) => ({ ...prev, [name]: date }));
    setError((prev) => ({ ...prev, [name]: date ? "" : prev[name] }));
  };

  const handleChange = (e) => {
    // const { name, value } = e?.target;
    // setFormData({ ...formData, [name]: value });

     const payloadData = {
         [e.target.name]: e.target.value,
     }

     setFormData((data) => ({
       ...data,
       ...payloadData 
    }));

    // Validation example
    if (!e.target.value) {
      // setError((prev) => ({ ...prev, [e.target.name]: "This field is required" }));
    } else {
      setError((prev) => ({ ...prev, [e.target.name]: "" }));
    }
  };

  const handleTextChange = (name, value) => {
    // const originalValue = value.replace(/<[^>]+>/g, '');
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onChecked = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const fetchData = async () => {
      if(CurrentUrlBaseMains === "/view/campaign" || CurrentUrlBaseMains === "/edit/campaign" ) {
              setLoaderStart(true);
              const response = await GetCampaignDetails(accessToken, GetSlug);
              if(response?.status === 200){
                  setLoaderStart(false);
                  setFormData({
                    ...formData,
                    campaign_type:response?.data?.details?.campaign_type,
                    non_profit:response?.data?.details?.non_profit,
                    campaign_start_date:new Date(response?.data?.start_date),
                    campaign_end_date:new Date(response?.data?.end_date),
                    source_image:response?.data?.details?.source_image,
                    initial_source_image:response?.data?.details?.initial_source_image,
                    campaign_goal:Number(response?.data?.details?.campaign_goal) / 100,
                    financial_progress:response?.data?.details?.financial_progress,
                    contributions_key_type:response?.data?.details?.contributions_key_type,
                    contributions_value_type:response?.data?.details?.contributions_key_type!=="multiple"&&Number(response?.data?.details?.contributions_value_type)/100,
                    campaign_title:response?.data?.title,
                    campaign_sub_title:response?.data?.subtitle,
                    campaign_description:response?.data?.description,
                    campaign_file_type:response?.data?.details?.campaign_file_type,
                    campaign_file_source:response?.data?.details?.campaign_file_type==="image" &&  response?.data?.details?.campaign_file_source,
                  
                    campaign_file_source2:response?.data?.details?.campaign_file_type==="video" && response?.data?.details?.campaign_file_source,
                    campaign_second_file_type:response?.data?.details?.campaign_second_file_type,
                    campaign_second_file_source:response?.data?.details?.campaign_second_file_source,
                    campaign_second_file_source2:response?.data?.details?.campaign_second_file_type==="video" && response?.data?.details?.campaign_file_source2,
                    avatar_validation:response?.data?.avatar_validation,
                    web_appearance:response?.data?.web_appearance,
                    sequence_no:response?.data?.web_appearance ? response?.data?.sequence_no :"",
                    company_title:response?.data?.details?.company_title,
                    company_description:response?.data?.details?.company_description,
                    company_file_type:response?.data?.details?.company_file_type,
                    company_file_source:response?.data?.details?.company_file_source,
                    company_file_source2:response?.data?.details?.company_file_type==="video"&&response?.data?.details?.company_file_source,
                    non_profit_title:response?.data?.details?.non_profit_title,
                    non_profit_description:response?.data?.details?.non_profit_description,
                    non_profit_file_type:response?.data?.details?.non_profit_file_type,
                    non_profit_file_source:response?.data?.details?.non_profit_file_source,
                    non_profit_file_source2:response?.data?.details?.non_profit_file_type==="video"&&response?.data?.details?.non_profit_file_source,
                    supporting_sponsors:response?.data?.details?.supporting_sponsors,
                    sponsor_signature:response?.data?.details?.sponsor_signature,
                    sponsor_logo:response?.data?.details?.sponsor_logo,
                    signature_logo:response?.data?.details?.signature_logo,
                    supporting_sponsors_campaign:response?.data?.details?.supporting_sponsors_campaign,
                    supporting_sponsor_logos:response?.data?.details?.supporting_sponsor_logos,
                    upload_slogan:response?.data?.details?.upload_slogan?.replace(/<[^>]+>/g, ''),
                  })
                  setPrices(response?.data?.details?.contributions_key_type==="multiple"?response?.data?.details?.contributions_value:[])
              }else{
                setLoaderStart(false);
                toast.error(response?.error || response.data.error);
              }
      }
   };
  useEffect(() => {
          if(CurrenUrlBase === "edit-campaign") {
              fetchData();
          };
  }, [ accessToken, CurrenUrlBase ]);

  const errorMap = {
    source_image: "initial_source_image",
    initial_source_image: "source_image",
  };
  const handleFileUpload = async (file, type, index) => {
    setUploadingFiles((prevState) => ({
      ...prevState,
      [type]: true,
    }));  

    const formDataUpload = new FormData();
    formDataUpload.append("file", file);

    try {
      const response = await UploadFile(accessToken, formDataUpload);
      const payloadResponse = {
        file_url_400: response?.file_url_400,
        file_url_700: response?.file_url_700,
        view_file_url: response?.view_file_url,
      };
      if (response) {
        if ( type === "signature_logo" || type === "supporting_sponsor_logos" || type === "campaign_second_file_source" || type === "campaign_file_source") {
          setFormData((prev) => ({
            ...prev,
            [type]: [...(prev[type] || []), payloadResponse],
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            [type]: payloadResponse,
          }));
          if (errorMap[type]) {
            setError((prev) => ({
              ...prev,
              [errorMap[type]]: "",
            }));
          }          
        }
        setError((prev) => ({
          ...prev,
          [type]: "",
        }));
      }
    } catch (error) {
      console.error("Upload failed", error);
    } finally {
      setUploadingFiles((prevState) => ({
        ...prevState,
        [type]: false, 
      }));
    }
  };

  const handleDeleteFile = (type, index) => {
    if ( type === "signature_logo" || type === "supporting_sponsor_logos" || type === "campaign_second_file_source" || type === "campaign_file_source") {
      setFormData((prev) => ({
        ...prev,
        [type]: prev[type].filter((_, i) => i !== index),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [type]: "",
      }));
    }
  };
  const AddCampaignFct = async () => {
    const valid =  validateFormData(formData,validationRules)
     if(Object.values(valid)?.length == 0){
     
    const payload = getPayloadCampaignAdd(formData);
    if (payload?.details?.supporting_sponsor_logos?.length > 0) {
      payload.has_sponsors = true;
    } else {
      payload.has_sponsors = false;
    }
    

    if (payload?.title) {
      payload.campaign_url = !formData.web_appearance ? `${API_URL_FOR_CREATING_COMPAIGN_URL}campaigns/${createSlug(payload.title)}`: null;
    }
    if (payload?.details) {
      payload.details.contributions_value_type = payload.details.contributions_key_type === "multiple" ? prices?.map(price => floatValue(Number(price?.amount)) * 100)  : floatValue(Number(formData?.contributions_value_type)) * 100; 
    }
    if (payload?.details) {
      payload.details.contributions_value = payload.details.contributions_key_type === "multiple" ? prices  : []; 
    }
    if (payload?.details){
      payload.details.campaign_goal = floatValue(Number(formData?.campaign_goal)) * 100
    }
    if (payload?.avatar_validation){
      payload.avatar_validation = formData?.avatar_validation
    }
    if (payload?.web_appearance){
      payload.web_appearance = formData?.web_appearance
    }

    if (payload?.details){
      payload.sequence_no = formData?.sequence_no ?  Number(formData?.sequence_no) :null
    }
    if (payload?.details){
      payload.details.initial_source_image = formData?.initial_source_image ? formData?.initial_source_image:  ""
    }
    //  console.log("payload",payload)
    setLoading(true);
    let response;
    if (CurrenUrlBase === "edit-campaign") {
      payload.campaign_id = GetSlug;
      response = await EditCampaign(accessToken, payload);
    } else {
      response = await AddCampaign(accessToken, payload);
    }
    setLoading(false);
    if (response?.status === 200) {
      setTimeout(() => {
        Navigate(CAMPAIGN_MANAGEMENT_URL);
        toast.success(response.msg);
      }, 100);
    } else {
      const errorMessage = response?.error || response?.data?.error || "Something went wrong";
      toast.error(errorMessage);
    }
    
     }else{
      setError((error)=>({
        ...error,
        ...valid,
    }))
     }


  };

  return (
    <>
      <ul className="tabcomnsection">
        {CurrenUrlBase === "add-campaign" ? (
          <li
            className={CurrenUrlBase === "add-campaign" ? "active" : ""}
            onClick={() => dispatch(SelectCampaignTab("add-campaign"))}
          >
            Add
          </li>
        ) : (
          <>
            <li
              className={CurrenUrlBase === "edit-campaign" ? "active" : ""}
              onClick={() => dispatch(SelectCampaignTab("edit-campaign"))}
            >
              Edit
            </li>
          </>
        )}
        <div className="tabheadebuttns">
          {CurrenUrlBase === "edit-campaign" && (
            <Button className="savchanges" onClick={() => AddCampaignFct()} disabled={loading}> {loading&&(<Spinner />)} Save</Button>
          )}
          {CurrenUrlBase === "add-campaign" && (
            <Button className="savchanges" onClick={() => AddCampaignFct()} disabled={loading}>
            {loading&&(<Spinner />)}
              Add
            </Button>
          )}
          <Link
            className="btn savchanges linksmanage"
            to={CAMPAIGN_MANAGEMENT_URL}
          >
            Back
          </Link>
        </div>
      </ul>
      <div className="formsectionset">
        <div className="tabcontent">
          <Scrollbars
            style={{ height: "calc(100vh - 162px)" }}
            className="ScrollbarsWrapper"
            renderView={(props) => <div {...props} className="view" />}>
            <div className="formloginset formeditset">
              <ModuleTitle title={"About You"} />
              <FormSelectCustome
                label="Are you an individual or an organization?"
                name="campaign_type"
                value={formData.campaign_type}
                options={Data?.optionCampaignType}
                onChange={handleChange}
                error={error?.campaign_type}
                required={true}
              />
              {formData.campaign_type==="Organization" && (
              <FormSelectCustome
                label="Are you a non profit?"
                name="non_profit"
                value={formData.non_profit}
                options={Data?.optionProfit}
                onChange={handleChange}
                error={error?.non_profit}
                required={true}
              />
              )}
             
              <ModuleTitle title={"Timeline"} />
              <div className="row">
                <div className="col-md-4">
                  <div className="">
                    <h4 className="label-required font-size d-flex">Campaign Date</h4>
                  </div>
                </div>
                <div className="col-md-8 d-flex p-0">
                  <DatePickerCustom
                    label="Start Date"
                    name="campaign_start_date"
                    selectedDate={formData.campaign_start_date}
                    onChange={handleDateChange}
                    endDate={formData.campaign_end_date}
                    selectsStart={true}
                    error={error.campaign_start_date}
                    minDate={new Date()}
                  />

                  <DatePickerCustom
                    label="End Date"
                    name="campaign_end_date"
                    selectedDate={formData.campaign_end_date}
                    onChange={handleDateChange}
                    startDate={formData.campaign_start_date}
                    selectsEnd={true}
                    minDate={formData.campaign_start_date}
                    error={error.campaign_end_date}
                  />
                </div>
              </div>

              <ModuleTitle title={"Mosaic Display"} />
              <FileUploader
                label="Please upload the image you want to transform into a mosaic. You can always change this later, before the final mosaic is created.  This will be used to bring your campaign to life. "
                name="source_image"
                type="source_image"
                value={formData.source_image}
                onUpload={(file) => handleFileUpload(file, "source_image")}
                onDelete={() => handleDeleteFile("source_image")}
                uploadFileLoader={uploadingFiles.source_image}
                isMultiple={false}
                error={error?.source_image}
                required={formData.initial_source_image ?  false : true}
                isLimit={20}
                isDownload={true}
                isCancel={true}
              />
              <FileUploader
                label="Initial Mosaic Image"
                name="initial_source_image"
                type="initial_source_image"
                value={formData.initial_source_image}
                onUpload={(file) => handleFileUpload(file, "initial_source_image")}
                onDelete={() => handleDeleteFile("initial_source_image")}
                uploadFileLoader={uploadingFiles.initial_source_image}
                isMultiple={false}
                error={error?.initial_source_image}
                required={formData.source_image ?  false : true}
                isLimit={20}
                isDownload={true}
                isCancel={true}
                infoMsg= {`The aspect ratio 16 / 9`} 
                infoIcon={true}
              />

              <ModuleTitle title={"Contributions"} />
              <FormInput
                label="What is your financial goal for this campaign?"
                name="campaign_goal"
                value={formData.campaign_goal}
                onChange={handleChange}
                onKeyDown={EmptySpaceFieldValid}
                placeholder="Financial goal"
                maxLength={100}
                error={error.campaign_goal}
                labelClassName="col-md-4"
                divClassName="col-md-8"
                required={true}
              />
              <SwitchCheckbox
                label="Would you like a financial progress bar to appear on your campaign page?"
                checked={formData?.financial_progress}
                onChange={(e) =>
                  onChecked({
                    target: {
                      name: "financial_progress",
                      value: e.target.checked,
                    },
                  })
                }
                name="financial_progress"
                id="custom-switch-avatar-validation"
              />
              <FormSelectCustome
                label="How do you want contributions to work?"
                name="contributions_key_type"
                value={formData.contributions_key_type}
                options={Data?.contributions_work}
                onChange={handleChange}
                error={error?.contributions_key_type}
                required={true}
              />
              {formData.contributions_key_type === "fixed" && (
                <FormInput
                  label="Fixed Amount"
                  name="contributions_value_type"
                  value={formData.contributions_value_type}
                  onChange={handleChange}
                  onKeyDown={EmptySpaceFieldValid}
                  placeholder="Enter fixed amount"
                  maxLength={100}
                  error={error.contributions_value_type}
                  labelClassName="col-md-4"
                  divClassName="col-md-8"
                />
              )}
              {formData.contributions_key_type === "minimum" && (
                <FormInput
                  label="Minimum Amount"
                  name="contributions_value_type"
                  value={formData.contributions_value_type}
                  onChange={handleChange}
                  onKeyDown={EmptySpaceFieldValid}
                  placeholder="Enter minimum amount"
                  maxLength={100}
                  error={error.contributions_value_type}
                  labelClassName="col-md-4"
                  divClassName="col-md-8"
                />
              )}
              {formData.contributions_key_type === "multiple" && (
                <>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="formgroups">
                        <h4 className="label font-size">
                          Multiple Amount type
                        </h4>
                      </div>
                    </div>
                    <div className="col-md-8 gap-2 d-flex flex-column">
                      <div className="d-flex gap-2 flex-wrap">
                        {prices
                          ?.sort((a, b) => a?.amount - b?.amount)
                          .map((price, index) => (
                            <div
                              key={index}
                              className="price_box position-relative border border-warning  p-2 bg-light">
                              <span>${price?.amount}{" "}{price?.text}</span>
                              <Button variant="danger"  size="sm" className="remove_price_button position-absolute top-0 right-0 translate-middle rounded-circle" onClick={() => removePrice(index)}> &times; </Button>
                            </div>
                          ))}
                      </div>
                      <div className="d-flex gap-2">
                        {prices?.length <= 4 && (
                          <div className="d-flex flex-column gap-2">
                            <div className="d-flex flex-row gap-2">
                               <div className="d-flex flex-column w-100">
                              <Form.Control type="number" value={newPrice} placeholder="Add Contributions Amount" onChange={handlePriceChange} className="add-price-btn"/>
                              {(priceError||error?.multiple_contributions) && (<p className="new_button_error">{priceError||error?.multiple_contributions}</p>)}
                               </div>

                              <div className="d-flex flex-column w-100">
                              <Form.Control type="text" value={msg} placeholder="Add Contributions Title" onChange={handleMsgChange}  className="add-price-btn"/>
                              {(msgError) && (<p className="new_button_error">{msgError}</p>)}
                              </div>
                             <Button size="sm" className="add_amount_button" onClick={addPrice}> Add </Button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}

              <ModuleTitle title={"Campaign Details"} />
              <FormInput
                label="Campaign Title"
                name="campaign_title"
                value={formData.campaign_title}
                onChange={handleChange}
                onKeyDown={EmptySpaceFieldValid}
                placeholder="Top of your webpage title."
                maxLength={100}
                error={error.campaign_title}
                labelClassName="col-md-4"
                divClassName="col-md-8"
                required={true}
              />
              <FormInput
                label="Campaign Subtitle"
                name="campaign_sub_title"
                value={formData.campaign_sub_title}
                onChange={handleChange}
                onKeyDown={EmptySpaceFieldValid}
                placeholder="A small summary beneath the title."
                maxLength={100}
                error={error.campaign_sub_title}
                labelClassName="col-md-4"
                divClassName="col-md-8"
                required={true}
              />
              <TextEditor
                label="Campaign Description"
                name="campaign_description"
                value={formData?.campaign_description}
                onChange={handleTextChange}
                error={error.campaign_description}
              />
              <FormSelectCustome
                label="Would you like a video or an image to be displayed above your description?"
                name="campaign_file_type"
                value={formData.campaign_file_type}
                options={Data?.link_type}
                onChange={handleChange}
                error={error?.campaign_file_type}
                required={true}
              />
              {formData.campaign_file_type === "image" && (
                <FileUploader
                  label="Upload Image or Logo"
                  name="campaign_file_source"
                  type="campaign_file_source"
                  value={formData.campaign_file_source}
                  error={error?.campaign_file_source}
                  onUpload={(file) =>handleFileUpload(file, "campaign_file_source")}
                  onDelete={(index) =>handleDeleteFile("campaign_file_source", index)}
                  uploadFileLoader={uploadingFiles.campaign_file_source}
                  isMultiple={true}
                />
              )}
              {formData.campaign_file_type === "video" && (
                <>
                  <VideoURLInput
                    label="Add Video"
                    onValidUrl={(url) =>{
                      setFormData((prev) => ({
                        ...prev,
                        campaign_file_source2: url,
                    })),
                    setError({
                      ...error,
                      campaign_file_source2:""
                    })
                    }}
                    existingVideos={[formData?.campaign_file_source2]}
                    errorVideo={error?.campaign_file_source2}
                  />
                </>)}
              <FormSelectCustome
                label="Would you like to add secondary images or videos underneath the description?"
                name="campaign_second_file_type"
                value={formData.campaign_second_file_type}
                options={Data?.link_type}
                onChange={handleChange}
                error={error?.campaign_second_file_type}
                required={false}
              />
              {formData.campaign_second_file_type === "image" && (
                <FileUploader
                  label="Upload Image or Logo"
                  name="campaign_second_file_source"
                  type="campaign_second_file_source"
                  value={formData.campaign_second_file_source}
                  onUpload={(file) =>handleFileUpload(file, "campaign_second_file_source")}
                  onDelete={(index) =>handleDeleteFile("campaign_second_file_source", index)}
                  uploadFileLoader={uploadingFiles.campaign_second_file_source}
                  isMultiple={true}
                />
              )}
              {formData.campaign_second_file_type === "video" && (
                <VideoURLInput
                  label="Add Video"
                  multiple
                  onValidUrl={(urls) =>
                    setFormData((prev) => ({
                      ...prev,
                      campaign_second_file_source2: urls,
                  }))}
                  existingVideos={formData?.campaign_second_file_source2}
                /> )}
              <SwitchCheckbox
                label="Avatar Validation"
                checked={formData?.avatar_validation}
                onChange={(e) =>
                  onChecked({
                    target: {
                      name: "avatar_validation",
                      value: e.target.checked,
                }})}
                name="avatar_validation"
                id="avatar_validation"
              />
              <SwitchCheckbox
                label="Web Appearance"
                checked={formData?.web_appearance}
                onChange={(e) =>
                  onChecked({
                    target: {
                      name: "web_appearance",
                      value: e.target.checked,
                }})}
                name="web_appearance"
                id="web_appearance"
              />
              {formData?.web_appearance && (
                <FormInput
                  label="Sequence Number"
                  name="sequence_no"
                  value={formData.sequence_no}
                  onChange={handleChange}
                  onKeyDown={EmptySpaceFieldValid}
                  placeholder="Enter Sequence number"
                  maxLength={100}
                  error={error.sequence_no}
                  labelClassName="col-md-4"
                  divClassName="col-md-8"
                  required={true}
                  infoMsg= {`${sequenceNumbers} This sequence of numbers are used. Please use a different numbers.`} 
                  infoIcon={true}
                />
              )}

              <ModuleTitle title={"Your Details"} />
              <FormInput
                label="Your Name"
                name="company_title"
                value={formData.company_title}
                onChange={handleChange}
                onKeyDown={EmptySpaceFieldValid}
                placeholder="Enter the name you'd like to be recognized by."
                maxLength={100}
                error={error.company_title}
                labelClassName="col-md-4"
                divClassName="col-md-8"
                required={true}
              />
              <TextEditor
                label="Your Description"
                name="company_description"
                value={formData.company_description}
                onChange={handleTextChange}
                error={error.company_description}
                placeholder="Share a little about yourself or your project."
              />
              <FormSelectCustome
                label="Would you like a video or an image to be displayed next to your description?"
                name="company_file_type"
                value={formData.company_file_type}
                options={Data?.link_type}
                onChange={handleChange}
                error={error?.company_file_type}
                required={true}
              />
              {formData?.company_file_type === "image" && (
                <FileUploader
                  label="Upload Image or Logo"
                  name="company_file_source"
                  type="company_file_source"
                  value={formData.company_file_source}
                  onUpload={(file) =>handleFileUpload(file, "company_file_source") }
                  onDelete={(index) =>handleDeleteFile("company_file_source", index)}
                  uploadFileLoader={uploadingFiles.company_file_source}
                  isMultiple={false}
                  error={error?.company_file_source}
                />
              )}
              {formData.company_file_type === "video" && (
                <>
                  <VideoURLInput
                    label="Add Video"
                    onValidUrl={(url) =>{
                    setFormData((prev) => ({
                        ...prev,
                        company_file_source2: url,
                      })),
                      setError({
                      ...error,
                      company_file_source2:""
                    })
                    }}
                    existingVideos={[formData?.company_file_source2]}
                    errorVideo={error?.company_file_source2}
                  />
                </>
              )}
              {(formData.non_profit === "Yes"&& formData.campaign_type==="Organization") && (
                <>
                  <ModuleTitle title={"Non-Profit Details"} />
                  <FormInput
                    label="Non-Profit Name"
                    name="non_profit_title"
                    value={formData.non_profit_title}
                    onChange={handleChange}
                    onKeyDown={EmptySpaceFieldValid}
                    placeholder="What’s the name of the non-profit?"
                    maxLength={100}
                    error={error.non_profit_title}
                    labelClassName="col-md-4"
                    divClassName="col-md-8"
                    required={true}
                  />
                  <TextEditor
                    label="Non-Profit Description"
                    name={"non_profit_description"}
                    value={formData.non_profit_description}
                    onChange={handleTextChange}
                    error={error.non_profit_description}
                    placeholder="Tell us about the mission or purpose of the non-profit."
                  />
                  <FormSelectCustome
                    label="Would you like a video or an image to be displayed next to your description?"
                    name="non_profit_file_type"
                    value={formData.non_profit_file_type}
                    options={Data?.link_type}
                    onChange={handleChange}
                    error={error?.non_profit_file_type}
                    required={true}
                  />
                  {formData?.non_profit_file_type === "image" && (
                    <FileUploader
                      label="Upload Image or Logo"
                      name="non_profit_file_source"
                      type="non_profit_file_source"
                      value={formData.non_profit_file_source}
                      onUpload={(file) =>handleFileUpload(file, "non_profit_file_source")}
                      onDelete={(index) =>handleDeleteFile("non_profit_file_source", index)}
                      uploadFileLoader={uploadingFiles.non_profit_file_source}
                      isMultiple={false}
                      error={error?.non_profit_file_source}
                    />
                  )}
                  {formData?.non_profit_file_type === "video" && (
                    <>
                      <VideoURLInput
                        label="Add Video"
                        onValidUrl={(url) =>{
                          setFormData((prev) => ({
                            ...prev,
                            non_profit_file_source2: url,
                          })),
                          setError({
                            ...error,
                            non_profit_file_source2:""
                          })
                        }}
                        existingVideos={[formData?.non_profit_file_source2]}
                        errorVideo={error?.non_profit_file_source2}
                      />
                    </>
                  )}
                </>
              )}

              <ModuleTitle title={"Sponsors"} />
              <FormSelectCustome
                label="Do you have any paying or supporting sponsors?"
                name="supporting_sponsors"
                value={formData?.supporting_sponsors}
                options={Data?.optionProfit}
                onChange={handleChange}
                error={error?.supporting_sponsors}
                required={true}
              />
              {formData?.supporting_sponsors === "Yes" && (
                <>
                  <FormSelectCustome
                    label="Do you have sponsors that have made monetary or significant contributions to your campaign as of today that require recognition on your campaign page and thank you email?"
                    name="sponsor_signature"
                    value={formData?.sponsor_signature}
                    options={Data?.optionProfit}
                    onChange={handleChange}
                    error={error?.sponsor_signature}
                    required={true}
                  />
                  {formData?.sponsor_signature === "Yes" && (
                    <>
                      <FileUploader
                        label="Upload Presenting Sponsor Logo"
                        name="sponsor_logo"
                        type="sponsor_logo"
                        value={formData.sponsor_logo}
                        onUpload={(file) =>handleFileUpload(file, "sponsor_logo")}
                        onDelete={(index) =>handleDeleteFile("sponsor_logo", index)}
                        uploadFileLoader={uploadingFiles.sponsor_logo}
                        isMultiple={false}
                        error={error?.sponsor_logo}
                      />
                      <FileUploader
                        label="Upload Signature Sponsor Logos"
                        name="signature_logo"
                        type="signature_logo"
                        value={formData.signature_logo}
                        onUpload={(file) =>handleFileUpload(file, "signature_logo")}
                        onDelete={(index) =>handleDeleteFile("signature_logo", index)}
                        uploadFileLoader={uploadingFiles.signature_logo}
                        isMultiple={true}
                      />
                    </>
                  )}

                  <ModuleTitle title={"Supporting Sponsors"} />
                  <FormSelectCustome
                    label="Do you have any supporting sponsors that have made, or plan to make non-monetary contributions to your campaign?"
                    name="supporting_sponsors_campaign"
                    value={formData?.supporting_sponsors_campaign}
                    options={Data?.optionProfit}
                    onChange={handleChange}
                    error={error?.supporting_sponsors_campaign}
                    required={true}
                  />
                  {formData?.supporting_sponsors_campaign == "Yes" && (
                    <FileUploader
                      label="Upload Supporting Sponsor Logos"
                      name="supporting_sponsor_logos"
                      type="supporting_sponsor_logos"
                      value={formData.supporting_sponsor_logos}
                      onUpload={(file) =>handleFileUpload(file, "supporting_sponsor_logos")}
                      onDelete={(index) =>handleDeleteFile("supporting_sponsor_logos", index)}
                      uploadFileLoader={uploadingFiles.supporting_sponsor_logos}
                      isMultiple={true}
                      error={error?.supporting_sponsor_logos}
                    />
                  )}
                </>
              )}

              <ModuleTitle title={"Contributions"} />
              <FormInput
                label="Personalize your “Upload Slogan” "
                name="upload_slogan"
                value={formData.upload_slogan}
                onChange={handleChange}
                onKeyDown={EmptySpaceFieldValid}
                placeholder="Create a slogan"
                maxLength={100}
                error={error.upload_slogan}
                labelClassName="col-md-4"
                divClassName="col-md-8"
                required={true}
              />
            </div>
          </Scrollbars>
        </div>
      </div>
      {LoaderStart && <CommonLoader classNameS={"charityLoader"} />}
      
    </>
  );
};
export default Add;
